// jQuery
jQuery(function ($) {
  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $(".totop");

  topBtn.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      300,
      "swing",
    );
    return false;
  });

  // -----------------------------
  // アコーディオン
  // -----------------------------
  // $('.js-accordion').each(function () {
  //   // 「is-show」が最初からついている要素は開いた状態にする
  //   if ($(this).hasClass('is-show')) {
  //     $(this).next('.js-accordion-contents').show();
  //   }
  // });

  // $('.js-accordion').click(function () {   // アコーディオンメニュー全体
  //   $(this).next('.js-accordion-contents').slideToggle();   // アコーディオンの隠されている要素
  //   $(this).toggleClass("is-show");   // メニューが開いたときのスタイル変化
  // });

  // -----------------------------
  // アコーディオン(入れ子も可能)
  // -----------------------------
  const speed = 200;

  // 初期状態：is-open が付いているものだけ開く
  $(".js-accordion.is-open").each(function () {
    const $item = $(this).closest(".accordion-item"); // closestが重要
    const $contents = $item.children(".js-accordion-contents");

    if ($contents.length) {
      $contents.show();
    }
  });

  // クリック（単体・入れ子 共通）
  $(document).on("click", ".js-accordion", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $trigger = $(this);
    const $item = $trigger.closest(".accordion-item");
    const $contents = $item.children(".js-accordion-contents");

    if (!$contents.length) return;

    $trigger.toggleClass("is-open");
    $contents.stop(true, true).slideToggle(speed);
  });

  // お知らせ記事内のPDFへのアイコン付与
  $(".postContents a").each(function () {
    const $a = $(this);
    const href = $a.attr("href");
    if (!href) return;

    if ($a.hasClass("link-pdf")) return;

    if (/\.pdf(\?.*)?$/i.test(href)) {
      $a.addClass("link-pdf");
    }
  });
});

// scrollhint
// new ScrollHint(".side-scroll-inner", {
//   suggestiveShadow: false,
//   i18n: { scrollable: "横にスクロールできます" },
// });

// メニュー用アコーディオン
// // ------------------------------------
// // Nested Accordion（header,footer用）
// // 親:      .js-nested-accordion-item
// // 見出し:  .js-nested-accordion-trigger
// // 中身:    .js-nested-accordion-contents
// // ------------------------------------
jQuery(function ($) {
  const speed = 200;

  const options = {
    enabledMQ: "(max-width: 1200px)", // Tabより小さい時
    exclusive: false, // trueで同階層は1つだけ開く
    initialOpenByTriggerClass: true, // triggerに is-open があれば初期open
  };

  const mq = window.matchMedia(options.enabledMQ);

  function setAria($trigger, open) {
    $trigger.attr("aria-expanded", open ? "true" : "false");
  }

  function openItem($item, animate = false) {
    const $trigger = $item.find(".js-nested-accordion-trigger").first();
    const $contents = $item.find(".js-nested-accordion-contents").first();
    if (!$trigger.length || !$contents.length) return;

    $item.addClass("is-open");
    $trigger.addClass("is-open");
    setAria($trigger, true);

    animate ? $contents.stop(true, true).slideDown(speed) : $contents.show();
  }

  function closeItem($item, animate = false) {
    const $trigger = $item.find(".js-nested-accordion-trigger").first();
    const $contents = $item.find(".js-nested-accordion-contents").first();
    if (!$trigger.length || !$contents.length) return;

    $item.removeClass("is-open");
    $trigger.removeClass("is-open");
    setAria($trigger, false);

    animate ? $contents.stop(true, true).slideUp(speed) : $contents.hide();
  }

  function applyMode() {
    const enabled = mq.matches;

    $(".js-nested-accordion-item").each(function () {
      const $item = $(this);
      const $trigger = $item.find(".js-nested-accordion-trigger").first();
      const $contents = $item.find(".js-nested-accordion-contents").first();
      if (!$trigger.length || !$contents.length) return;

      if (enabled) {
        const shouldOpen =
          $item.hasClass("is-open") ||
          (options.initialOpenByTriggerClass && $trigger.hasClass("is-open"));

        shouldOpen ? openItem($item, false) : closeItem($item, false);
      } else {
        // PCは常時表示（リンクとして動かす）
        $contents.show();
        $item.removeClass("is-open");
        $trigger.removeClass("is-open");
        setAria($trigger, true);
      }
    });
  }

  applyMode();
  mq.addEventListener("change", applyMode);

  // クリック（委譲）
  $(document).on("click", ".js-nested-accordion-trigger", function (e) {
    if (!mq.matches) return; // PCは通常リンク

    e.preventDefault();
    e.stopPropagation();

    const $trigger = $(this);
    const $item = $trigger.closest(".js-nested-accordion-item");
    const $contents = $item.children(".js-nested-accordion-contents");
    if (!$contents.length) return;

    const isOpen = $item.hasClass("is-open");

    if (options.exclusive) {
      // 同階層だけ閉じる（入れ子でも階層維持）
      $item
        .parent()
        .children(".js-nested-accordion-item")
        .not($item)
        .each(function () {
          closeItem($(this), true);
        });
    }

    isOpen ? closeItem($item, true) : openItem($item, true);
  });

  // 少しでもスクロールしたらクラス削除（0より大きい=1pxでも）
  const $win = $(window);
  const $header = $(".js-scroll-target"); // 付けたい対象に合わせて変更
  const topClass = "not-scrolled";

  function toggleTopClass() {
    $header.toggleClass(topClass, $win.scrollTop() === 0);
  }

  toggleTopClass(); // 初期反映（リロード時も）
  $win.on("scroll", toggleTopClass);
});

// ヘッダーメニューホバーしたらオーバーレイON
const navItems = document.querySelectorAll(".headerGnav-ttl");
navItems.forEach((item) => {
  const drop = item.querySelector(".headerGnavDrop");

  if (!drop) return; // ← ドロップ無いメニューは無視

  item.addEventListener("mouseenter", () => {
    document.body.classList.add("nav-open");
  });

  item.addEventListener("mouseleave", () => {
    document.body.classList.remove("nav-open");
  });
});

// ヘッダー（SP用ハンバーガーメニュー）
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector(".js-hamburger");
  const nav = document.querySelector(".headerGNavSp");

  if (!btn || !nav) return;

  const open = () => {
    btn.setAttribute("aria-expanded", "true");
    nav.setAttribute("aria-hidden", "false");
    nav.classList.add("is-open");

    // 任意：背面スクロール固定
    document.body.style.overflow = "hidden";
  };

  const close = () => {
    btn.setAttribute("aria-expanded", "false");
    nav.setAttribute("aria-hidden", "true");
    nav.classList.remove("is-open");

    // 任意：背面スクロール固定解除
    document.body.style.overflow = "";
  };

  btn.addEventListener("click", () => {
    const isOpen = nav.classList.contains("is-open");
    isOpen ? close() : open();
  });

  // 任意：メニュー内リンクを押したら閉じる
  nav.addEventListener("click", (e) => {
    const a = e.target.closest("a");
    if (a) close();
  });

  // 任意：Escで閉じる
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
});

window.addEventListener("load", () => {
  const target = document.documentElement; // 付け先（例：html）
  const className = "scrolled";

  const threshold = 80; // 80pxスクロールしたら付ける

  const onScroll = () => {
    if (window.scrollY >= threshold) {
      target.classList.add(className);
      window.removeEventListener("scroll", onScroll); // 1回だけなら外す
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll(); // 既にスクロールされてる場合にも対応
});

// お知らせ年指定
const newsYearSelect = document.getElementById("js-newsYear");
if (newsYearSelect) {
  newsYearSelect.addEventListener("change", function () {
    location.href = this.value;
  });
}

// スライドアップアニメーション
document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".slideUp");

  const io = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add("is-inview");
        observer.unobserve(entry.target); // 1回だけ再生
      });
    },
    {
      root: null,
      threshold: 0.2, // 20%見えたら発火
      rootMargin: "0px 0px 11% 0px", // 少し早め/遅め調整用（下方向マージン）
    },
  );

  targets.forEach((el) => io.observe(el));
});
